import { REFERRAL_STATS_FETCH } from 'src/constants/actionTypes';
import { get } from 'src/actions/actionCreators';

export const fetchReferralStats = () =>
  get(REFERRAL_STATS_FETCH, `/user/referral-stats`);
